import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../lib/AuthContext";
import { Input } from "../components/ui/input";
import { Label } from "../components/ui/label";
import { PawPrint, ShieldCheck } from "lucide-react";
import { formatApiErrorDetail } from "../lib/api";
import { setMeta } from "../lib/seo";

export default function AdminLogin() {
  const { login } = useAuth();
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    setMeta("robots", "noindex, nofollow");
    return () => setMeta("robots", "index, follow");
  }, []);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      await login(email, password);
      nav("/admin");
    } catch (err) {
      setError(formatApiErrorDetail(err.response?.data?.detail) || err.message || "Login failed");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center px-4" style={{ background: "var(--pm-bg)" }}>
      <div className="w-full max-w-md neo-card p-8" data-testid="admin-login-card">
        <div className="flex items-center gap-2 mb-2">
          <span
            className="w-10 h-10 rounded-lg flex items-center justify-center"
            style={{ background: "var(--pm-dog)", border: "2px solid #0F172A" }}
          >
            <PawPrint className="text-white" size={20} />
          </span>
          <span className="font-display text-2xl font-bold">Pet Munchies</span>
        </div>
        <h1 className="font-display text-2xl font-bold mt-3 flex items-center gap-2">
          <ShieldCheck size={22} /> Admin Login
        </h1>
        <p className="text-sm text-slate-600">Sign in to manage orders and products.</p>

        <form onSubmit={submit} className="mt-6 space-y-4" data-testid="admin-login-form">
          <div>
            <Label className="text-sm font-semibold mb-1 block">Email</Label>
            <Input
              type="email"
              required
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              data-testid="admin-email-input"
              autoComplete="username"
            />
          </div>
          <div>
            <Label className="text-sm font-semibold mb-1 block">Password</Label>
            <Input
              type="password"
              required
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              data-testid="admin-password-input"
              autoComplete="current-password"
            />
          </div>
          {error && (
            <div className="text-sm font-semibold text-red-600" data-testid="admin-login-error">{error}</div>
          )}
          <button
            type="submit"
            disabled={loading}
            className="neo-btn w-full py-3 text-white font-bold"
            style={{ background: "var(--pm-dog)" }}
            data-testid="admin-login-submit"
          >
            {loading ? "Signing in…" : "Sign In"}
          </button>
        </form>
        <p className="text-xs text-slate-500 mt-4 text-center">Protected by JWT + brute-force lockout.</p>
      </div>
    </div>
  );
}
